import {
  Bot,
  ShieldCheck,
  Zap,
  MessageSquare,
  Cpu,
  Database
} from 'lucide-react'

const features = [
  {
    icon: Bot,
    title: 'Autonomous Agents',
    description:
      'AI that doesn\'t just talk—it acts. Manage tasks, calendars, and emails automatically through your personal assistant.',
  },
  {
    icon: ShieldCheck,
    title: 'Isolated Environments',
    description:
      'Each agent runs in its own secure, isolated VM on GCP. Your data and credentials stay protected and private.',
  },
  {
    icon: Zap,
    title: 'Instant Provisioning',
    description:
      'Automated deployment pipeline handles everything from server creation to agent startup in under 60 seconds.',
  },
  {
    icon: Cpu,
    title: 'Multi-Model Brains',
    description:
      'Choose your preferred AI logic—powered by GPT-4, Claude 3.5, or Gemini—to handle your most complex workflows.',
  },
  {
    icon: MessageSquare,
    title: 'Chat App Integration',
    description:
      'Connect your agent to Telegram or Slack seamlessly. Control your digital life through the chat apps you already use.',
  },
  {
    icon: Database,
    title: 'Persistent Memory',
    description:
      'Long-term memory storage allows your agent to remember your preferences and past interactions for a truly personalized experience.',
  },
]

export function Features() {
  return (
    <section id="features" className="py-24 px-6 relative z-10">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16 animate-in fade-in slide-in-from-bottom-8 duration-700">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Deploy{' '}
            <span className="brand-gradient-text">The QuickClaw Way</span> 🦞
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Everything you need to run your own AI personal assistant, without
            the infrastructure headaches.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl bg-card/60 backdrop-blur-sm border border-border hover:border-primary/50 transition-all duration-300 shadow-[0_4px_24px_rgba(0,0,0,0.2)] hover:shadow-[0_4px_24px_rgba(245,61,16,0.1)] hover:scale-[1.02] animate-in fade-in slide-in-from-bottom-4 fill-mode-backwards"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary to-orange-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg shadow-orange-500/20">
                <feature.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
